import { render } from "./pl35dan.vue?vue&type=template&id=803f8614&scoped=true"
import script from "./pl35dan.vue?vue&type=script&lang=js"
export * from "./pl35dan.vue?vue&type=script&lang=js"

import "./pl35dan.vue?vue&type=style&index=0&id=803f8614&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-803f8614"]])

export default __exports__